import { ViewLoadInspectionNoDamages } from './ViewLoadInspectionNoDamages';
import { ViewLoadInspectionDamagePhotos } from './ViewLoadInspectionDamagePhotos';
import { Stack, Columns, Column } from '@superdispatch/ui';
import { TextBox } from '@superdispatch/ui-lab';
import { joinStrings } from 'shared/utils/StringUtils';
import { LoadVehicleInspectionDTO } from '../../../loads/data/LoadDTO';

export function ViewLoadAIAGInspectionDamages({
  inspection,
}: {
  inspection: LoadVehicleInspectionDTO['aiag_inspections'][number];
}) {
  return !inspection.damages?.length ? (
    <ViewLoadInspectionNoDamages />
  ) : (
    <Stack space="xsmall">
      <TextBox variant="heading-5">Damages</TextBox>
      <Stack space="medium">
        {inspection.damages.map(({ area, type, severity, photos }, index) => (
          <Columns
            align="center"
            space="medium"
            key={index}
            collapseBelow="tablet"
          >
            <Column width="content">
              <TextBox variant="heading-3">
                {joinStrings(' ', area.code, type.code, severity.code)}
              </TextBox>
            </Column>
            <Column width="fluid">
              <Stack space="xxsmall">
                <TextBox>
                  {area.code}. {area.description}
                </TextBox>
                <TextBox>
                  {type.code}. {type.description}
                </TextBox>
                <TextBox>
                  {severity.code}. {severity.description}
                </TextBox>
              </Stack>
            </Column>
            <Column width="content">
              <ViewLoadInspectionDamagePhotos photos={photos} />
            </Column>
          </Columns>
        ))}
      </Stack>
    </Stack>
  );
}
